import { Activity, Brain, Baby, Flower2, HeartPulse, Feather } from 'lucide-react';

/**
 * The "Big Tent" clinical focus tracks — kept in sync with the backend
 * CLINICAL_FOCUS_TRACKS (server.py). Two featured "High Demand" tracks +
 * four equal-weight standard tracks. Shared by the supply-side landing page
 * (Specialty Navigator) and the clinician onboarding multi-select.
 */
export const CLINICAL_FOCUS_TRACKS = [
  {
    id: 'post_acute_recovery',
    name: 'Post-Acute Recovery',
    featured: true,
    Icon: Activity,
    tagline: 'Surgical discharge · Wound care · IV therapy',
    keywords: ['Surgical discharge', 'Wound care', 'IV Therapy'],
  },
  {
    id: 'behavioral_health',
    name: 'Behavioral Health',
    featured: true,
    Icon: Brain,
    tagline: 'Psych nursing · Neuro-cognitive · Crisis stabilization',
    keywords: ['Psych nursing', 'Neuro-cognitive', 'Crisis stabilization'],
  },
  {
    id: 'pediatrics_neonatal',
    name: 'Pediatrics & Neonatal',
    featured: false,
    Icon: Baby,
    tagline: 'Newborn, pediatric & family-centered home care',
    keywords: ['NICU', 'Pediatric home care', 'Family support'],
  },
  {
    id: 'geriatric_wellness',
    name: 'Geriatric & Wellness',
    featured: false,
    Icon: Flower2,
    tagline: 'Aging-in-place, companionship & preventive care',
    keywords: ['Aging in place', 'Wellness visits', 'Companion care'],
  },
  {
    id: 'chronic_disease',
    name: 'Chronic Disease Management',
    featured: false,
    Icon: HeartPulse,
    tagline: 'Diabetes, COPD, CHF & complex chronic care',
    keywords: ['Diabetes', 'COPD', 'CHF'],
  },
  {
    id: 'palliative_hospice',
    name: 'Palliative & Hospice',
    featured: false,
    Icon: Feather,
    tagline: 'Comfort-focused & end-of-life care',
    keywords: ['Symptom management', 'Hospice', 'Family support'],
  },
];

export const FOCUS_TRACK_BY_ID = CLINICAL_FOCUS_TRACKS.reduce((acc, t) => {
  acc[t.id] = t;
  return acc;
}, {});

/** License types accepted at sign-up — MUST match matching_engine.LicenseLevel. */
export const LICENSE_TYPES = [
  { value: 'RN', label: 'RN — Registered Nurse' },
  { value: 'LPN', label: 'LPN — Licensed Practical Nurse' },
  { value: 'CNA', label: 'CNA — Certified Nursing Assistant' },
  { value: 'NP', label: 'NP — Nurse Practitioner' },
  { value: 'MD', label: 'MD — Physician' },
  { value: 'MSW', label: 'MSW — Medical Social Worker' },
  { value: 'PT', label: 'PT — Physical Therapist' },
  { value: 'OT', label: 'OT — Occupational Therapist' },
];
